module.exports = __webpack_public_path__ + "static/media/Bitmap@2x.11d99445.png";